/* eslint-disable no-param-reassign */
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import { COMPONENT, NETWORK, CONTAINER, SITE } from '@/aquassist-shared/constants/types/node';
import {
    CLOSED,
    COOLING,
    DEALKALIZER,
    FEEDWATERDEAERATOR,
    POLISHER,
    SOFTENER,
    BOILER,
} from '@/aquassist-shared/constants/types/components';
import {
    STEAM,
} from '@/aquassist-shared/constants/types/network';

import lockService from '@/utilities/lockService';
import EventBus from '@/utilities/event-bus';
import nodesType from '@/utilities/enums/nodesTypes';
import Boiler from '@/components/forms/technicalFile/boiler/main';
import Cooling from '@/components/forms/technicalFile/cooling/main';
import ClosedLoop from '@/components/forms/technicalFile/closedLoop/main';
import ButtonIcon from '@/components/shared/widgets/ButtonIconTooltip';
import Menu from '@/components/shared/navigation/BaseMenu';
import CopySite from '@/components/forms/copySite/main';
import NetworkTechFIle from '@/components/forms/technicalFile/network/main';
import SteamTechFile from '@/components/forms/technicalFile/network/steam/main';
import SoftPolisherDealk from '@/components/forms/technicalFile/softPolisherDealk/main';
import ConfirmForm from '@/components/shared/widgets/ConfirmForm.vue';
import FeedWaterOrDeaerator from '../components/forms/technicalFile/feedWaterDeaerator/main.vue';
import TreeDuplicateComponentForm from '../components/sites/TreeDuplicateComponentForm.vue';


export default {
    components: {
        ButtonIcon,
        Menu,
    },
    props: {
        // NODE INFO RELATED
        id: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: 'Recursive Tree',
        },
        // can be Site, Component, Network or Container
        nodeType: {
            type: String,
            default: '',
        },
        // id of the nodeType
        nodeTypeId: {
            type: String,
            default: '',
        },
        // chidlren's node
        nodes: {
            type: null,
            default: () => [],
        },
        // depth of the tree
        depth: {
            type: Number,
            default: 0,
        },
        // the whole node
        nodeItem: {
            type: Object,
            default: () => {},
        },
        // their parent
        parentNode: {
            type: Object,
            default: () => {},
        },
        // SITE COMPONENT RELATED
        site: {
            type: Object,
            default: () => ({}),
        },
        editMode: {
            type: Boolean,
            default: false,
        },
        showAll: {
            type: Boolean,
            default: false,
        },
        path: {
            type: String,
            default: '',
        },
        showInactive: {
            type: Boolean,
            default: false,
        },
        isSelectMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showChildren: false,
            iconType: 'home',
            nodesType,
            key: this.$utils.generateRandomString(),
            mutableShowAll: this.showAll,
            mutableNodeItem: {},
        };
    },
    computed: {

        ...mapGetters([
            'hasPermission',
            'selectedTree',
        ]),

        siteId() {
            return this.site.id || this.site.ref;
        },
        indent() {
            let indent = '0';
            if (this.nodeType !== SITE) {
                indent = '25px';
                if (this.$vuetify.breakpoint.mdAndDown) {
                    indent = '11px';
                }
            }
            return {
                width: 'inherit',
                marginLeft: indent,
            };
        },
        leaf() {
            return this.nodes.length === 0;
        },
        nodeTitle() {
            return (this.nodeType.length === 0)
                ? `${this.name} (Site) [${this.mutableNodeItem ? this.mutableNodeItem.deliveryAccountNumber : ''}]`
                : `${this.name} (${this.$t(`sites.nodes.${this.nodeType.toLowerCase()}`)})`;
        },
        nodeName() {
            return (this.nodeType.length === 0)
                ? `${this.name} (Site) [${this.mutableNodeItem ? this.mutableNodeItem.deliveryAccountNumber : ''}]`
                : `${this.name}`;
        },
        nodeState() {
            return this.isActive ? null : `(${this.$t('generic.inactive')})`;
        },
        iconArrow() {
            return this.mutableNodeItem.showChildren ? 'mdi-menu-down' : 'mdi-menu-right';
        },
        emptyMessage() {
            return this.$t('msg.childrenEmpty');
        },
        isNodeEmpty() {
            return !this.nodes.length && this.leaf && this.mutableNodeItem.showChildren
            && (!this.analyses || !this.analyses.length);
        },
        pathName() {
            if (this.mutableNodeItem) {
                return this.path
                    ? this.mutableNodeItem.name
                    : `${this.path} - ${this.mutableNodeItem.name}`;
            }

            return '';
        },
        isActive() {
            return this.mutableNodeItem ? this.mutableNodeItem.active : false;
        },
        // TODO - Bg color of what? This is not telling me the color and where are the class. Please fix
        bgColor() {
            if (!this.isActive) {
                return 'disabled';
            }

            switch (this.nodeType) {
                case SITE:
                    return 'sites';
                case CONTAINER:
                    return 'containers';
                case NETWORK:
                    return 'networks';
                default:
                    return (this.isActive) ? 'components' : 'disabled';
            }
        },
    },
    watch: {
        showAll: {
            handler() {
                this.mutableShowAll = this.showAll;
            },
            immediate: true,
        },
        nodeItem: {
            handler() {
                this.mutableNodeItem = { ...this.nodeItem };
            },
            immediate: true,
        },
    },
    created() {
        this.mutableNodeItem.showChildren = (this.nodeType !== COMPONENT) ? this.mutableShowAll : false;
    },
    methods: {
        async showTechnicalFile(event) {
            const node = { ...event };
            const id = node.ref ? node.ref : node.id;
            // Tech file just valid for the Network and Component nodes
            switch (node.nodeType) {
                case NETWORK:
                    node.nodeType = NETWORK.toLowerCase();
                    node.network = id;
                    break;
                case COMPONENT:
                    node.nodeType = COMPONENT.toLowerCase();
                    node.component = id;
                    break;
                default:
                    return;
            }

            const listSoftPolisherDealk = [DEALKALIZER, SOFTENER, POLISHER];
            const isSoftPolisher = listSoftPolisherDealk.includes(node.type.key);

            const feedWaterOrDaerator = FEEDWATERDEAERATOR;
            const isFeedWaterOrDaerator = node.type.key === feedWaterOrDaerator;
            if (node.nodeType === COMPONENT.toLowerCase() && node.type.key && isSoftPolisher) {
                const componentId = node.ref;
                const lockAcquired = await lockService.requestLock(componentId, 'TechnicalFileSoftPolisherDealk');
                if (!lockAcquired) {
                    EventBus.$emit('open-lock-queue-modal', {
                        componentId,
                        retrieveLock: async () => lockService.requestLock(componentId, 'TechnicalFileSoftPolisherDealk'),
                        retryFunction: () => {
                            this.openSoftPolisherDealk(node);
                        },
                    });
                    return;
                }
                this.openSoftPolisherDealk(node);
                return;
            }
            if (node.nodeType === COMPONENT.toLowerCase() && node.type.key && isFeedWaterOrDaerator) {
                const componentId = node.ref;
                const lockAcquired = await lockService.requestLock(componentId, 'TechnicalFileFeedWaterDaerator');
                if (!lockAcquired) {
                    EventBus.$emit('open-lock-queue-modal', {
                        componentId,
                        retrieveLock: async () => lockService.requestLock(componentId, 'TechnicalFileFeedWaterDaerator'),
                        retryFunction: () => {
                            this.openFeedWaterDaerator(node);
                        },
                    });
                    return;
                }
                this.openFeedWaterDaerator(node);
                return;
            }
            if (node.nodeType === COMPONENT.toLowerCase() && node.type.key && node.type.key === CLOSED) {
                const componentId = node.ref;
                const lockAcquired = await lockService.requestLock(componentId, 'TechnicalFileClosedLoop');
                if (!lockAcquired) {
                    EventBus.$emit('open-lock-queue-modal', {
                        componentId,
                        retrieveLock: async () => lockService.requestLock(componentId, 'TechnicalFileClosedLoop'),
                        retryFunction: () => {
                            this.openClosedLoop(node);
                        },
                    });
                    return;
                }
                this.openClosedLoop(node);
                return;
            }
            if (node.nodeType === COMPONENT.toLowerCase() && node.type.key && node.type.key === COOLING) {
                const componentId = node.ref;
                const lockAcquired = await lockService.requestLock(componentId, 'TechnicalFileCooling');
                if (!lockAcquired) {
                    EventBus.$emit('open-lock-queue-modal', {
                        componentId,
                        retrieveLock: async () => lockService.requestLock(componentId, 'TechnicalFileCooling'),
                        retryFunction: () => {
                            this.openCooling(node);
                        },
                    });
                    return;
                }
                this.openCooling(node);
                return;
            }
            if (node.nodeType === COMPONENT.toLowerCase() && node.type.key && node.type.key === BOILER) {
                const componentId = node.ref;
                const lockAcquired = await lockService.requestLock(componentId, 'TechnicalFileBoiler');
                if (!lockAcquired) {
                    EventBus.$emit('open-lock-queue-modal', {
                        componentId,
                        retrieveLock: async () => lockService.requestLock(componentId, 'TechnicalFileBoiler'),
                        retryFunction: () => {
                            this.openBoiler(node);
                        },
                    });
                    return;
                }
                this.openBoiler(node);
                return;
            }
            if (node.nodeType === NETWORK.toLowerCase() && node.type.key && node.type.key !== STEAM) {
                const componentId = node.ref;
                const lockAcquired = await lockService.requestLock(componentId, 'TechnicalFileNetwork');
                if (!lockAcquired) {
                    EventBus.$emit('open-lock-queue-modal', {
                        componentId,
                        retrieveLock: async () => lockService.requestLock(componentId, 'TechnicalFileNetwork'),
                        retryFunction: () => {
                            this.openNetwork(node);
                        },
                    });
                    return;
                }
                this.openNetwork(node);
                return;
            }
            if (node.nodeType === NETWORK.toLowerCase() && node.type.key && node.type.key === STEAM) {
                const componentId = node.ref;
                const lockAcquired = await lockService.requestLock(componentId, 'TechnicalFileNetworkSteam');
                if (!lockAcquired) {
                    EventBus.$emit('open-lock-queue-modal', {
                        componentId,
                        retrieveLock: async () => lockService.requestLock(componentId, 'TechnicalFileNetworkSteam'),
                        retryFunction: () => {
                            this.openNetworkSteam(node);
                        },
                    });
                    return;
                }
                this.openNetworkSteam(node);
            }
        },
        toggleChildren() {
            this.nodeItemChanged({ ...this.mutableNodeItem, nodeType: this.nodeType, showChildren: !this.mutableNodeItem.showChildren });
        },
        sendAction(action, item) {
            EventBus.$emit('node-action', [action, item]);
        },
        // Find all the files recursively in a dynamic forms object
        findFiles(object, files = []) {
            const hasFields = Array.isArray(object.fields) && object.fields.length > 0;
            let newFiles = files;

            if (hasFields) {
                object.fields.forEach(field => {
                    if (typeof field === 'object') {
                        if (field.fieldType === 'fileUpload') {
                            files.push(field);
                        }

                        newFiles = this.findFiles(field, files);
                    }
                });
            }

            return newFiles;
        },
        openCooling(node) {
            const payload = {
                node,
                netWorkName: node.parentNode.name,
                showBreadcrumbs: node.showBreadcrumbs,
            };
            this.$root.$emit('showModal', {
                title: this.$t('technicalFile.cooling.title'),
                component: Vue.component('Cooling', Cooling),
                payload,
                showNextPrevious: true,
                showSaveBtn: true,
                onConfirm: async data => {
                    if (data) {
                        const formData = new FormData();
                        if (data?.otherInformation.newFiles?.length) {
                            data.otherInformation.newFiles.forEach(file => {
                                if (file) formData.append('file', file);
                            });
                        }
                        if (data?.otherInformation.files?.length) {
                            // eslint-disable-next-line no-param-reassign, no-underscore-dangle
                            data.otherInformation.files = data.otherInformation.files.map(file => file.id || file._id);
                        }

                        if (data?.otherInformation.history?.length) {
                            this.removeUpdatedByInformationFromHistory(data);
                        }
                        formData.append('payload', JSON.stringify(data));
                        await this.$rq.updateTechfile(this.siteId, node.ref, formData);
                        this.$toasted.global.toast_success({
                            message: this.$t('sites.technicalFileUpdated', { name: node.name, type: node.nodeType }),
                        });
                    }
                },
            });
        },
        openBoiler(node) {
            const payload = {
                node,
                netWorkName: node?.parentNode?.name,
                showBreadcrumbs: node?.showBreadcrumbs,
            };
            this.$root.$emit('showModal', {
                title: this.$t('technicalFile.boiler.title'),
                component: Vue.component('Boiler', Boiler),
                payload,
                showNextPrevious: true,
                onConfirm: async data => {
                    if (data) {
                        const formData = new FormData();
                        if (data?.otherInformation.newFiles?.length) {
                            data.otherInformation.newFiles.forEach(file => {
                                if (file) formData.append('file', file);
                            });
                        }
                        if (data?.otherInformation.files?.length) {
                            // eslint-disable-next-line no-param-reassign, no-underscore-dangle
                            data.otherInformation.files = data.otherInformation.files.map(file => file.id || file._id);
                        }
                        formData.append('payload', JSON.stringify(data));
                        await this.$rq.updateTechfile(this.siteId, node.ref, formData);
                        this.$toasted.global.toast_success({
                            message: this.$t('sites.technicalFileUpdated', { name: node.name, type: node.nodeType }),
                        });
                    }
                },
            });
        },
        openClosedLoop(node) {
            const payload = {
                node,
                netWorkName: node?.parentNode?.name,
                showBreadcrumbs: node?.showBreadcrumbs,
            };
            this.$root.$emit('showModal', {
                title: this.$t('technicalFile.closedLoop.title'),
                component: Vue.component('ClosedLoop', ClosedLoop),
                payload,
                showNextPrevious: true,
                onConfirm: async data => {
                    if (data) {
                        data.isClosedLoop = true;
                        const formData = new FormData();
                        formData.append('payload', JSON.stringify(data));
                        await this.$rq.updateTechfile(this.siteId, node.ref, formData);
                        this.$toasted.global.toast_success({
                            message: this.$t('sites.technicalFileUpdated', { name: node.name, type: node.nodeType }),
                        });
                    }
                },
            });
        },

        openNetwork(node) {
            const payload = {
                node,
                netWorkName: node?.parentNode?.name,
                showBreadcrumbs: node?.showBreadcrumbs,
            };
            this.$root.$emit('showModal', {
                title: this.$t('sites.technicalFile', { name: node.name, type: node.type ? node.type.key : 'Site' }),
                component: Vue.component('NetworkTechFIle', NetworkTechFIle),
                payload,
                showNextPrevious: true,
                width: 800,
                onConfirm: async data => {
                    if (data) {
                        const formData = new FormData();
                        if (data?.networkInfos.newFiles?.length) {
                            data.networkInfos.newFiles.forEach(file => {
                                if (file) formData.append('file', file);
                            });
                            delete data.networkInfos.newFiles;
                        }
                        if (data?.networkInfos.files?.length) {
                            // eslint-disable-next-line no-param-reassign, no-underscore-dangle
                            data.networkInfos.files = data.networkInfos.files.map(file => file._id || file.id);
                        }
                        formData.append('payload', JSON.stringify(data));
                        await this.$rq.updateTechfile(this.siteId, node.ref, formData);
                        this.$toasted.global.toast_success({
                            message: this.$t('sites.technicalFileUpdated', { name: node.name, type: node.nodeType }),
                        });
                    }
                },
            });
        },

        openNetworkSteam(node) {
            const payload = {
                node,
                netWorkName: node?.parentNode?.name,
                showBreadcrumbs: node?.showBreadcrumbs,
            };
            this.$root.$emit('showModal', {
                title: this.$t('sites.technicalFile', { name: node.name, type: node.type ? node.type.key : 'Site' }),
                component: Vue.component('SteamTechFIle', SteamTechFile),
                payload,
                showNextPrevious: true,
                width: 800,
                onConfirm: async data => {
                    if (data) {
                        const formData = new FormData();
                        formData.append('payload', JSON.stringify(data));
                        await this.$rq.updateTechfile(this.siteId, node.ref, formData);
                        this.$toasted.global.toast_success({
                            message: this.$t('sites.technicalFileUpdated', { name: node.name, type: node.nodeType }),
                        });
                    }
                },
            });
        },
        openSoftPolisherDealk(node) {
            const payload = {
                node,
                netWorkName: node?.parentNode?.name,
                showBreadcrumbs: node?.showBreadcrumbs,
            };
            this.$root.$emit('showModal', {
                title: this.$t('sites.technicalFile', { name: node.name, type: node.type ? node.type.key : 'Site' }),
                component: Vue.component('SoftPolisherDealkTechFIle', SoftPolisherDealk),
                payload,
                width: 800,
                onConfirm: async data => {
                    if (data) {
                        const formData = new FormData();
                        formData.append('payload', JSON.stringify(data));
                        await this.$rq.updateTechfile(this.siteId, node.ref, formData);
                        this.$toasted.global.toast_success({
                            message: this.$t('sites.technicalFileUpdated', { name: node.name, type: node.nodeType }),
                        });
                    }
                },
            });
        },

        openFeedWaterDaerator(node) {
            const payload = {
                node,
                netWorkName: node?.parentNode?.name,
                showBreadcrumbs: node?.showBreadcrumbs,
            };
            this.$root.$emit('showModal', {
                title: this.$t('sites.technicalFile', { name: node.name, type: node.type ? node.type.key : 'Site' }),
                component: Vue.component('FeedWaterOrDeaerator', FeedWaterOrDeaerator),
                payload,
                width: 800,
                onConfirm: async data => {
                    if (data) {
                        const formData = new FormData();
                        formData.append('payload', JSON.stringify(data));
                        await this.$rq.updateTechfile(this.siteId, node.ref, formData);
                        this.$toasted.global.toast_success({
                            message: this.$t('sites.technicalFileUpdated', { name: node.name, type: node.nodeType }),
                        });
                    }
                },
            });
        },


        showCopySite(currentSite) {
            const payload = {
                currentSite,
            };
            this.$root.$emit('showModal', {
                title: this.$t('copySite.title'),
                component: Vue.component('CopySite', CopySite),
                payload,
                showNextPrevious: true,
                onConfirm: async data => {
                    if (data && !isEmpty(data.selectedTreeNodes)) {
                        const content = { ...data };
                        await this.$rq.copySiteTreeFromAnotherSite(this.siteId, content);
                        this.$toasted.global.toast_success({
                            message: this.$t('sites.siteCopied'),
                        });
                        this.$emit('reloadTree');
                    }
                },
            });
        },
        getSiteTree(node, nodeId) {
            const response = { ref: node.id, ...node };
            if (!node.children?.length) return response;
            response.children = node.children.map(value => {
                if (value.ref === nodeId) {
                    return {
                        ...value,
                        isSelected: true,
                        children: value.children
                            ? value.children.map(el => ({ ...el, isSelected: true })) : undefined,
                    };
                }
                if (value.children) {
                    return this.getSiteTree(value, nodeId);
                }
                return value;
            });
            return response;
        },
        duplicateNode(currentNode) {
            if (currentNode.node.nodeType === 'Component') {
                this.duplicateComponent(currentNode);
            } else {
                this.$root.$emit('showModal', {
                    title: this.$t('sites.tooltip.duplicate'),
                    component: Vue.component('ConfirmForm', ConfirmForm),
                    payload: {
                        msg: this.$t('sites.confirmDuplicate'),
                        node: currentNode.node,
                        netWorkName: currentNode.parentNode.name,
                        showBreadcrumbs: currentNode.showBreadcrumbs,
                    },
                    isForm: false,
                    onConfirm: async () => {
                        const siteTree = this.getSiteTree(this.site, currentNode?.node?.ref);
                        const content = {
                            selectedSite: this.siteId,
                            analyses: {
                                standards: true,
                                workOrderType: true,
                            },
                            others: {
                                graphics: false,
                                alerts: false,
                            },
                            selectedTreeNodes: { ...siteTree },
                            isDuplicate: true,
                        };
                        await this.$rq.copySiteTreeFromAnotherSite(this.siteId, content);
                        this.$toasted.global.toast_success({
                            message: this.$t('sites.siteDuplicated'),
                        });
                        this.$emit('reloadTree');
                    },
                });
            }
        },
        findNode(array, ref) {
            let response = null;
            for (let i = 0; i < array.length; i += 1) {
                if (array[i].ref === ref) {
                    response = array[i];
                    break;
                } else if (array[i].children && array[i].children.length > 0) {
                    response = this.findNode(array[i].children, ref);
                    if (response !== null) break;
                }
            }
            return response;
        },
        nodeItemChanged(value) {
            this.$emit('nodeItemChanged', value);
        },
        addNodeWithEachName(data) {
            data.forEach(node => {
                // eslint-disable-next-line no-param-reassign
                node.name = `${node.name} (${this.$t(`graphics.series.label.${node.nodeType.charAt(0).toLowerCase() + node.nodeType.slice(1)}`)})`;
                if (node.children && node.children.length > 0) {
                    this.addNodeWithEachName(node.children);
                }
            });
        },
        async duplicateComponent(currentNode) {
            this.$root.$emit('showModal', {
                title: this.$t('sites.tooltip.duplicate'),
                component: Vue.component('componentDuplicateForm', TreeDuplicateComponentForm),
                payload: {
                    msg: this.$t('sites.confirmDuplicate'),
                    component: currentNode.node,
                    network: currentNode.parentNode,
                    netWorkName: currentNode.parentNode.name,
                    showBreadcrumbs: true,
                },
                isForm: false,
                onConfirm: async data => {
                    const siteTree = this.getSiteTree(this.site, currentNode?.node?.ref);
                    const content = {
                        selectedSite: this.siteId,
                        duplicateProperties: {
                            ...data,
                        },
                        analyses: {
                            standards: true,
                            workOrderType: true,
                            controlChart: false,
                        },
                        others: {
                            graphics: false,
                            alerts: false,
                        },
                        selectedTreeNodes: { ...siteTree },
                        isDuplicate: true,
                    };
                    await this.$rq.copySiteTreeFromAnotherSite(this.siteId, content);
                    this.$toasted.global.toast_success({
                        message: this.$t('sites.siteDuplicated'),
                    });
                    this.$emit('reloadTree');
                },
            });
        },
        removeUpdatedByInformationFromHistory(data) {
            data.history = data.history.map(element => ({
                ...element,
                // eslint-disable-next-line no-underscore-dangle
                updatedBy: element.updatedBy ? element.updatedBy._id : element.updatedBy,
            }));
        },
    },
};
